<script setup>
import { computed } from "vue";
import ChannelIcon from "dashboard/components-next/icon/ChannelIcon.vue";

const props = defineProps({
  inbox: {
    type: Object,
    default: () => ({}),
  },
});

const visualInbox = computed(() => {
  const inbox = props.inbox || {};
  const inboxId = Number(inbox.id ?? inbox.inbox_id ?? inbox.inboxId);
  const inboxName = String(inbox.name || "").trim().toLowerCase();

  const isInstagramMiMarciana =
    inboxId === 10 ||
    inboxName === "mi marciana moda" ||
    inboxName.includes("instagram");

  const isWhatsAppMiMarciana =
    inboxId === 11 ||
    inboxName === "whatsapp mi marciana" ||
    inboxName.includes("whatsapp");

  if (isInstagramMiMarciana) {
    return {
      ...inbox,
      channel_type: "Channel::Instagram",
      channelType: "Channel::Instagram",
    };
  }

  if (isWhatsAppMiMarciana) {
    return {
      ...inbox,
      channel_type: "Channel::Whatsapp",
      channelType: "Channel::Whatsapp",
      medium: "whatsapp",
    };
  }

  return inbox;
});
</script>

<template>
  <div :title="inbox.name" class="flex items-center gap-0.5 min-w-0">
    <ChannelIcon
      :inbox="visualInbox"
      use-brand-icon
      class="size-4 flex-shrink-0"
    />
    <span class="truncate text-body-main text-n-slate-11">
      {{ inbox.name }}
    </span>
  </div>
</template>
